/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {Link} from '@material-ui/core';

interface SideSheetBreadCrumbLinkProps {
  linkClass: any;
  onLinkClick?: (e: any) => void;
  linkLabel: string;
}
/**
 * @SideSheetBreadCrumbLink
 * Returns utility component for breadcrumb link.
 * 
 *  ```typescript
 *   import SideSheetBreadCrumbLink from '@/routes/tracking/sidesheet/SideSheetBreadCrumbLink';
 * 
 *   <SideSheetBreadCrumbLink linkClass={classes.linkClass} onLinkClick={function(e) {}} linkLabel={linkLabel}/>
 *  ```
 */
export const SideSheetBreadCrumbLink = ({
  linkClass,
  onLinkClick,
  linkLabel
}: SideSheetBreadCrumbLinkProps) => {
  return (
    <Link style={{textDecoration: 'none'}}
      className={linkClass}
      onClick={onLinkClick}>
      {linkLabel}
    </Link>
  );
};
